import { Component, ChangeDetectionStrategy } from '@angular/core';

import { SnCameraGrid } from '@lib/api/entities';
import { snListStagger, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-camera-grid-table',
  templateUrl: './camera-grid-table.component.html',
  styleUrls: ['./camera-grid-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CameraGridTableComponent extends SnTableBaseComponent<SnCameraGrid> {
  constructor() {
    super();
  }

  public trackBy(index: number, item: SnCameraGrid): any {
    return item.id;
  }

  public formatName(firstName: string, lastName: string): any {
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }
    return;
  }
}
